import { Box, Typography, BoxProps, Paper, Stack } from "@mui/material";
import React from "react";

interface CreateStepsLayoutProps {
  title: string;
  children: React.ReactNode;
  containerProps?: BoxProps;
}

const CreateStepsLayout = ({
  title,
  children,
  containerProps
}: CreateStepsLayoutProps): React.ReactNode => {
  return (
    <>
      <Stack
        gap={1}
        top={0}
        sx={{
          border: 0,
          width: "100%",
          borderRadius: 0,
          maxWidth: (theme) => `calc(960px + ${theme.spacing(4)})`
        }}
      >
        <Typography variant="h5">{title}</Typography>
      </Stack>
      <Box
        p={4}
        mt={2}
        borderRadius={2}
        component={Paper}
        elevation={3}
        {...containerProps}
        sx={{
          width: "100%",
          flexGrow: 1,
          ...containerProps?.sx
        }}
      >
        {children}
      </Box>
    </>
  );
};

export default CreateStepsLayout;
